<template>
  <div v-loading="loading" class="body">
    <el-container>
      <el-main>
        <el-row>
          <el-col>
            <div v-if="!loading" class="authform login" :class="modal">
              <el-card>
                <el-row type="flex" class="row-bg" justify="end">
                  <LangSelector />
                </el-row>
                <component v-bind:is="modal"></component>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import LoginForm from '@/components/LoginForm';
import RegisterForm from '@/components/Register';
import EmailVerify from '@/components/emailverify';
import LangSelector from '@/components/LangSelector';
import PasswordReset from '@/components/password-reset';
import 'element-ui/lib/theme-chalk/display.css';
export default {
  name: 'Login',
  components: {
    LoginForm,
    RegisterForm,
    PasswordReset,
    LangSelector,
    EmailVerify
  },
  props: {
    modal: { type: String, default: 'LoginForm' }
  },
  data() {
    return {
      loading: true
    };
  },
  computed: {
    ...mapState('data', {
      Translations: state => state.Translations
    })
  },
  created() {
    let _this = this;
    _this.getTranslations().then(function() {
      setTimeout(function() {
        _this.loading = false;
      }, 1000);
    });
  },
  methods: {
    ...mapActions('data', ['getTranslations'])
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../assets/scss/main.scss';
.body {
  background: url(../assets/images/main-image.jpg) center top / cover no-repeat;
  background-attachment: fixed;
}
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
  li {
    display: block;
    background: red;
  }
}
/*li {*/
/*display: inline-block;*/
/*margin: 0 10px;*/
/*}*/
a {
  color: #42b983;
}

.el-main {
  min-height: 100vh;
}

.login-container .login-form {
  position: absolute;
  left: 0;
  right: 0;
  // width: 520px;
  // padding: 35px 35px 15px 35px;
  // margin: 120px auto;
}

.authform {
  width: 500px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.06);
  margin-left: calc(50% - 250px);
  text-align: left;
}

.LoginForm {
  margin-top: 150px;
  margin: 150px auto 0;
}

.RegisterForm,
.PasswordReset {
  margin-top: 20px;
}

.EmailVerify {
  margin-top: 25vh;
}

.register-workflow {
  padding-right: 10px;
  padding-left: 10px;
}

// @media (max-width: 1219px) {
//   .login {
//     width: 464px;
//     left: 0;
//   }
// }
@media (max-width: 530px) {
  .login {
    margin: 0 auto;
    width: 400px;
  }

  .EmailVerify {
    margin-top: 25vh;
  }
}
@media (max-width: 435px) {
  .login {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue